export interface MonthlyReport {
  id: number; //	★primary id
  period: Date; //	★yyyy-mm-01
  user_id: number;  //	★dr_user.id

  login_user_id: string; //	ログインID（旧 user_id）
  user_name: string;  //	氏名
  cap_id: string; //	口座番号
  cur: string;  //	通貨
  rate: number; // レート
  hdc: number;  //	手数料（成功報酬手数料）
  monthly_management_fee: number;  //	管理手数料

  before_high_water_mark: number;  //	前月ハイウォーターマーク
  bal_a: number;  //	月初残高
  nyukin: number;  //	入金額
  adjust_amount: number;  // 調整額
  adjust_comment: string; // 調整コメント

  nyukin_high_water_mark: number;  //	入金後ハイウォーターマーク
  balance_start: number;  //	月初残高
  balance_start_jpy: number;  // 月初残高(JPY)

  swap_per: number|null; //  スワップ損益(%)'
  trade_per: number|null; //  取引損益(%)
  monthly_per: number|null; //  月間損益(%)'
  swap_pl: number; //  スワップ損益
  trade_pl: number; //  取引損益
  monthly_pl: number; //  月間損益

  balance_before_fees: number;  //	手数料徴収前残高
  high_water_mark: number;  //	当月ハイウォーターマーク

  success_fee_pl: number; // 成功報酬対象損益
  hc_a: number;  //	成功報酬手数料
  management_fee: number; // 月間管理手数料
  hc_b: number;  //	その他手数料
  hc_b_comment: string; // その他手数料コメント

  balance_after_fees: number; // 手数料徴収後残高

  pension: number;  // 年金出金額
  shukkin: number;  //	出金額
  transfer_amount: number;  // 振替額
  transfer_hdc: number; // 振替先の成功報酬手数料率
  transfer_pool: string;  // 振替先POOL
  transfer_note: string;  // 振替先の note
  bal_b	: number;  //月末残高
  bal_b_jpy	: number;  //月末残高(JPY)

  eom_high_water_mark: number;  //	当月末ハイウォーターマーク
  rate_b: number; // 手数料徴収後収益率(%)

  status: typeof MonthlyReportStatus[number]; // 月末の状態
  transfer_from: string; // 振替元口座番号

  flg: string;  //	JACは共同名義
  cmm: string;  //	共同名義者名
  enroll:	Date;   //  運用開始日
  res_b: number;  //	拘束期間
  chg: Date|undefined;  //	拘束期間終了日
  cancel: Date; //	解約日
  note: string; //	解約日等

  is_public: boolean; //	公開状態（TODO: 現在は個別の公開・非公開は行わず MonthlyReportIndex で制御するので未使用）
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;

  is_full_withdrawal: boolean;  // 全額出金処理フラグ
  is_full_transfer: boolean;  // 全額振替処理フラグ
}

export const MonthlyReportStatus = ['運用中', '口座閉鎖'] as const;

export const MonthlyReportIndexStatus = ['月初処理中', '月末処理中', '月報確定', '公開状態'] as const;

export interface MonthlyReportIndex {
  id: number;
  period: Date;
  ad: number;
  status: typeof MonthlyReportIndexStatus[number];
  is_public: boolean;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;

  reports: MonthlyReport[]; // isPrev=false の時
  reports_count: number; // isPrev=true の時
}

export const Currencies = ['JPY', 'USD', 'GBP', 'AUD', 'EUR', 'CHF'] as const;
